import { AttributeValue } from "@/graphql/utils";

import { AbtestState } from "./graphql";

export const LAST_NOTIFICATION_ID_SEEN = "voodootune-releasenote-notification-last-id-opened";
export const DEVELOPER_MODE = "developerMode";

export const icons = {
  wip: "traffic-plot-icon",
  live: "live-icon",
};

export const typeToDefaultValueMapping: Record<string, AttributeValue> = {
  string: "",
  boolean: false,
  integer: 0,
  float: 0,
  "string[]": [],
  "integer[]": [],
  "float[]": [],
  select: "",
  multiselect: [],
  version: "0.0.0",
  json: "",
};

export const inputTypeToAttributeTypeMapping: Record<string, string> = {
  text: "string",
  string: "string",
  integer: "integer",
  float: "float",
  tags: "string[]",
  select: "string",
  multiselect: "string[]",
  json: "json",
};

export const inputTypeLabels: Record<string, string> = {
  string: "text",
  boolean: "boolean",
  integer: "integer",
  float: "float",
  json: "json",
  "string[]": "strings array",
  "integer[]": "integers array",
  "float[]": "floats array",
  select: "select",
  multiselect: "multiselect",
  version: "version",
};

export const classAttributeTypeChoices = Object.entries(inputTypeLabels)
  .map(([value, label]) => ({ label, value }))
  .filter(({ value }) => value !== "version");

export const cohortColorsPalette = [
  "#2196F3",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#FF9570",
  "#FFC107",
  "#FF9800",
  "#795548",
  "#607D8B",
  "#FF5722",
  "#8BC34A",
  "#F44336",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
];

export const ABTEST_STATES = {
  draft: "draft",
  pending: "pending",
  published: "published",
  terminating: "terminating",
  archived: "archived",
};

export const ABTEST_STATES_COLOR_MAPPING: Record<AbtestState, string> = {
  DRAFT: "info",
  PENDING: "",
  PUBLISHED: "success",
  TERMINATING: "warning",
  ARCHIVED: "danger",
};

export const PROVIDED_VALUES = {
  UPDATE_PAGE_TITLE: "updatePageTitle",
  IN_WIP_VERSION: "inWIPVersion",
  GAME: {
    BUNDLE_ID: "bundleId",
  },
};

export const GLOBAL_DOCUMENTATION_LINK = "https://www.notion.so/voodoo/VoodooTune-06d8f80ea5df42e683fd3335727cc6bd";
export const DYNAMIC_INSTANCES_ALLOWED_APP_IDS = [
  "85d0179c-4108-4a69-a4d8-6eab15dd4e3b", // Handy Craft
  "81e20062-9fb5-471e-8233-17c247abbae3", // Voodoo Sauce test App
  "02095f71-26f8-4cc7-9d1b-c8cb6eeed342", // VoodooTune Test App
];

export const SHOP_ITEM_CONDITIONS_ALLOWED_APP_IDS = [
  "85d0179c-4108-4a69-a4d8-6eab15dd4e3b", // Handy Craft
  "81e20062-9fb5-471e-8233-17c247abbae3", // Voodoo Sauce test App
  "26281ef1-3bb2-45c2-90c5-3f3907cadb6e", // VOODOO LIVE
  "02095f71-26f8-4cc7-9d1b-c8cb6eeed342", // VoodooTune Test App
];

export const PRICING_TEMPLATE_ALLOWED_APP_IDS = [
  "81e20062-9fb5-471e-8233-17c247abbae3", // Voodoo Sauce test App
  "26281ef1-3bb2-45c2-90c5-3f3907cadb6e", // VOODOO LIVE
  "02095f71-26f8-4cc7-9d1b-c8cb6eeed342", // VoodooTune Test App
  "85d0179c-4108-4a69-a4d8-6eab15dd4e3b", // Handy Craft
  "9e27177f-5873-4a82-9c68-90a65ef3d45d", // Cup Heroes
  "01101cf5-7334-4afb-ba70-c81f76a4761b", // Block Jam 3D
  "a3af8f0e-bedc-462c-8d87-34a98b11cf87", // Card Factory
  "544420cc-617e-47a1-ab96-1ca6f4037872", // Marble Sort
  "011427d4-6224-415f-9f8a-c9dd2bd4224f", // Block Pals
  "e316e511-8e70-400c-825d-6c4500f11103", // Gear Fight
];
